import ConfirmDialog from '@components/Modals/ConfirmDialog';
import useDraftOrderDetail from '@contexts/useDraftOrderDetail';

interface CancelConfirmDialogProps {
  onClose: () => void;
  onConfirm: () => void;
  cancelReturnsToPatient?: boolean;
}

function getReturnPageName(cancelReturnsToPatient: boolean, hasDraftOrder: boolean): string {
  if (cancelReturnsToPatient) {
    return 'Patient Detail';
  }
  if (hasDraftOrder) {
    return 'Draft Orders';
  }
  return 'Orders and Reports';
}

export default function CancelConfirmDialog({
  onClose,
  onConfirm,
  cancelReturnsToPatient = false,
}: CancelConfirmDialogProps) {
  const { draftOrder } = useDraftOrderDetail();
  const returnPage = getReturnPageName(cancelReturnsToPatient, Boolean(draftOrder?.identifier));

  return (
    <ConfirmDialog
      title='Cancel and Return'
      description={`Do you want to return to the ${returnPage} page? Your order form progress will be lost.`}
      onClose={onClose}
      onConfirm={onConfirm}
      modalProps={{
        'aria-labelledby': 'cancel-return-modal-title',
        'data-testid': 'requisitionCancelConfirmDialog',
        id: 'cancel-return-confirm-dialog',
      }}
      cancelBtnProps={{
        'data-testid': 'createRequisitionCloseConfirmBtn',
      }}
    />
  );
}
